import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BaseAreaAccordionComponent } from '../base-accordion.component';
import { AccordionService } from 'src/app/services/accordion.service';

@Component({
  selector: 'app-area-details-detections',
  templateUrl: './area-details-detections.component.html',
  styleUrls: ['./area-details-detections.component.scss'],
})
export class AreaDetailsDetectionsComponent extends BaseAreaAccordionComponent {
  @Input() detections;
  @Input() visitId: number;
  @Input() date: string;
  @Input() dayNumber: string;
  @Input() areaId: number;
  @Input() visit?: any; // Add visit input
  @Input() isEditingDisabled = false;
  @Output()
  saveFields = new EventEmitter();

  constructor(private router: Router, accordionService: AccordionService) {
    super(accordionService);
  }

  // Computed property to check if form should be disabled
  get isFormDisabled(): boolean {
    return this.isEditingDisabled;
  }

  goToAction(detection) {
    this.saveFields.emit();
    this.router.navigate(['/action'], {
      state: {
        backUrl: `/area/${this.date}/${this.visitId}/${this.dayNumber}/${this.areaId}`,
        parentObject: 'PC.Detection',
        parentId: detection.id,
        customerId: detection.customerId,
        locationId: detection.locationId,
        areaId: this.areaId,
        actionId: detection.actionId ? detection.actionId : 0,
      },
    });
  }
}
